<template>
  <section id="page" class="section">
    <Header class="scrolled"/>
    <div class="articleDetail staticContent loading" v-if="loading"></div>
    <div class="articleDetail staticContent" v-else>
      <div class="cnt">
        <div class="bcnb">
          <div class="breadcrumb">
            <a href="/" class="bc">Home</a>
            <span class="dv">/</span>
            <span class="bc" v-if="lang === 'id'">{{detail.title}}</span>
            <span class="bc" v-if="lang === 'en'">{{detail.titleEn}}</span>
          </div>
        </div>
      </div>

      <div class="content">
        <h2 class="articleTitle" v-if="lang === 'id'">{{detail.title}}</h2>
        <h2 class="articleTitle" v-if="lang === 'en'">{{detail.titleEn}}</h2>
        <div class="articleShare articleShareStatic" v-if="1>2">
          <h4>Share</h4>
          <div class="shareCnt">
            <a target="_balnk"
              :href="`https://www.facebook.com/sharer/sharer.php?u=${shareUri}`">
              <i class="fa fa-facebook fa-fw"></i>
            </a>
            <a target="_balnk"
              :href="`https://twitter.com/intent/tweet?text=${detail.title}&amp;url=${shareUri}`">
              <i class="fa fa-twitter fa-fw"></i>
            </a>
            <a :href="`whatsapp://send?text=${detail.title} ${shareUri}`">
              <i class="fa fa-whatsapp fa-fw"></i>
            </a>
            <a target="_balnk"
              :href="`https://telegram.me/share/url?url=${shareUri}&amp;text=${detail.title}`">
              <i class="fa fa-telegram fa-fw"></i>
            </a>
            <a :href="`mailto:?subject=${detail.title}&amp;body=Check this out:
              <a href='${shareUri}'>${detail.title}</a>`">
              <i class="fa fa-email fa-fw"></i>
            </a>
          </div>
        </div>
        <div class="articleContent">
          <div v-if="detail.slug === 'privacy'">
            <p>When you use our services, you’re trusting us with your
              information. We understand that this is a big responsibility
              and we work hard to protect your information and put you in control.</p>
              <br />
            <p>This Privacy Policy is meant to help you understand what information
              we collect, why we collect it and how you can update, manage,
              export and delete your information.</p>
            <br />
          </div>
          <div v-if="detail.slug === 'terms'">
            <p>What’s covered in these terms.</p>
              <br />
            <p>We know it’s tempting to skip these Terms of Service,
              but it’s important to establish what you can expect
              from us as you use ICEL Website, and
              what we expect from you.</p>
            <br />
          </div>
          <div v-else>
            <div v-html="detail.keteranganTambahan" v-if="lang === 'id'"></div>
            <div v-html="detail.keteranganTambahanEn" v-else-if="lang === 'en'"></div>
          </div>
        </div>
      </div>

      <div class="articleShare" :style="{top: `${shareTop}px`}" v-if="1>2">
        <h4>Share</h4>
        <div class="shareCnt">
          <a target="_balnk"
            :href="`https://www.facebook.com/sharer/sharer.php?u=${shareUri}`">
            <i class="fa fa-facebook fa-fw"></i>
          </a>
          <a target="_balnk"
            :href="`https://twitter.com/intent/tweet?text=${detail.title}&amp;url=${shareUri}`">
            <i class="fa fa-twitter fa-fw"></i>
          </a>
          <a :href="`whatsapp://send?text=${detail.title} ${shareUri}`">
            <i class="fa fa-whatsapp fa-fw"></i>
          </a>
          <a target="_balnk"
            :href="`https://telegram.me/share/url?url=${shareUri}&amp;text=${detail.title}`">
            <i class="fa fa-telegram fa-fw"></i>
          </a>
          <a :href="`mailto:?subject=${detail.title}&amp;body=Check this out:
            <a href='${shareUri}'>${detail.title}</a>`">
            <i class="fa fa-email fa-fw"></i>
          </a>
        </div>
      </div>
      <div ref="endArticle"/>
    </div>
    <Footer/>
  </section>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';

export default {
  name: 'read',
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      detail: { slug: '', title: '...' },
      related: [],
      shareTop: 192,
      loading: false,
      shareUri: '',
      lang: 'id',
    };
  },
  methods: {
    onScrolled() {
      const currentScrollPos = window.pageYOffset;
      const aHRect = this.$refs.endArticle.getBoundingClientRect();
      if (aHRect.top > 420) {
        this.shareTop = 192 + currentScrollPos;
      }
    },
    getData() {
      this.$http.get(this.$config.uri(`content/${this.detail.slug}`)).then((r) => {
        this.loading = false;
        this.detail = (r.data.status === 200) ? r.data.data : { slug: '', title: '...' };
        if (this.detail.category) {
          this.shareUri = `${this.$config.appUri}static/${this.detail.category.slug}/${this.detail.slug}`;
        }
      });
    },
  },
  created() {
    window.addEventListener('scroll', this.onScrolled);
  },
  destroyed() {
    window.removeEventListener('scroll', this.onScrolled);
  },
  mounted() {
    this.lang = localStorage.getItem('portal_putusan_penting_icel_lang');
    if (!this.lang) this.lang = window.navigator.userLanguage || window.navigator.language;
    if (this.lang === 'en-US' || this.lang === 'en') this.lang = 'en';
    else if (this.lang === 'id-ID' || this.lang === 'id') this.lang = 'id';
    else this.lang = 'id';
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.detail.slug = this.$route.params.slug;
    switch (this.detail.slug) {
      case 'privacy':
        this.detail.title = 'Privacy Policy';
        this.shareUri = `${this.$config.appUri}static/privacy`;
        break;
      case 'terms':
        this.detail.title = 'Terms Of Service';
        this.shareUri = `${this.$config.appUri}static/terms`;
        break;
      // case 'bantuan': this.detail.title = 'Bantuan'; break;
      // case 'methodology': this.detail.title = 'Methodology'; break;
      // case 'glosarium': this.detail.title = 'Glosarium'; break;
      // case 'guideline': this.detail.title = 'Guideline'; break;
      default:
        this.loading = true;
        this.getData();
        break;
    }
  },
};
</script>

<style lang="scss">
.articleDetail.staticContent{
  .content{
    max-width: 750px;
    margin: 0 auto;
    @media (max-width: 960px) {
      max-width: none;
      margin: 0 20px;
    }
    .articleTitle{
      font-size: 40px;
      margin: 0;
      font-weight: bold;
      line-height: 1.3;
      margin-bottom: 20px;
    }
    .articleContent{
      font-size: 19px;
      line-height: 1.5;
      text-align: justify;
      blockquote{
        font-size: 26px;
        line-height: 1.3;
        border-left: #ddd 4px solid;
        position: relative;
        margin: 26px 0;
        padding-bottom: 6px;
        color: #767676;
        padding-left: 50px;
        padding-left: 30px;
        &:before{
          content: "\"";
          font-size: 80px;
          position: absolute;
          left: 14px; top: -14px;
          display: none;
        }
      }
      h2{
        // letter-spacing: -1px;
        font-weight: 600;
      }
      h3{
        margin-bottom: 10px;
      }
      p.caption{
        margin: -14px 0 20px 10px;
        font-size: 15px;
        line-height: 1.4;
        min-height: 22px;
        font-style: italic;
      }

      p{
        margin: 0;
      }
      iframe.theMedia{
        height: 420px;
        border: none;
        @media (max-width: 700px){
          height: 200px;
        }
      }
      .theMedia{
        display: block;
        margin: 20px 0;
        width: 100%;
        border-radius: 5px;
        position: relative;
        z-index: 3;
        &.md-wide{
          width: calc(100% + 200px);
          margin: 20px -100px;
          @media (max-width: 974px) {
            width: calc(100% + 100px);
            margin: 20px -50px;
          }
          @media (max-width: 874px) {
            width: calc(100% + 40px);
            margin: 20px -20px;
            border-radius: 0;
          }
        }
      }
    }
  }
  @media (max-width: 700px) {
    padding: 60px 0 30px;
    .content{
      .articleTitle{
        font-size: 30px;
        line-height: 1.3;
        margin-bottom: 10px;
      }
      .articleContent{
        font-size: 18px;
        line-height: 1.6;
      }
    }
  }
}
</style>

<style scoped lang="scss">
.articleDetail.staticContent{
  padding: 60px 0;
  // font-family: 'Source Serif Pro', serif;
  box-sizing: border-box;
  min-height: 100vh;
  &.loading{
    background-image: url(../assets/loading.svg);
    background-position: center;
    background-repeat: no-repeat;
    background-size: 46px auto;
  }
}
.bcnb{
  margin: 0;
  // font-family: 'Source Serif Pro', serif;
}
</style>

<style scoped lang="scss">
  .relatedTitle{
    width: 100%;
    margin: 0;
    margin-bottom: 14px;
    font-size: 20px;
    padding-top: 40px;
  }
  .relatedCnt{
    display: flex;
    margin-right: -20px;
    flex-wrap: wrap;
    .relatedItem{
      width: calc(33.3333% - 20px);
      margin-right: auto;
      .relatedImg{
        height: 236px;
        background-size: cover;
        background-position: center;
        background-color: #eee;
        margin-bottom: 10px;
        transition: all .2s ease;
        &:hover{
          transform: scale(1.02);
          box-shadow: 4px 4px 0 #31c1f4;
        }
      }
      a{
        text-decoration: none;
        color: #444;
        &:hover{
          color: #31c1f4;
        }
      }
      h4{
        margin: 0;
        padding-left: 7px;
      }
    }
  }
  @media (max-width: 760px){
    .relatedSc{
      margin: 0 -20px;
      overflow-x: auto;
      .relatedCnt{
        width: 780px;
        padding-left: 20px;
        padding-bottom: 10px;
        .relatedItem{
          margin: 0;
          width: 240px;
          margin-right: 20px;
          .relatedImg{
            height: 240px;
            border-radius: 10px;
          }
        }
      }
    }
  }

  .authorInfo{
    position: relative;
    padding-top: 8px;
    // padding-left: 50px;
    padding-bottom: 30px;
    @media (max-width: 700px) {
      padding-bottom: 16px;
    }
    .authorImg{
      position: absolute;
      left: 0;
      top: 8px;
      width: 39px;
      height: 39px;
      background-color: #ccc;
      background-image: url(../assets/user.png);
      background-size: cover;
      border-radius: 50%;
      cursor: pointer;
      display: none;
    }
    h4{
      margin: 0;
      font-size: 17px;
    }
    .publishTime{
      margin: 0;
      font-size: 14px;
    }
  }

  .articleShare{
    position: absolute;
    top: 192px;
    left: calc(((100% - 750px) / 2) - 80px);
    padding: 12px 10px 5px;
    z-index: 9;
    background-color: #fff;
    border-radius: 5px;
    // font-family: 'Source Serif Pro', serif;
    @media (max-width: 960px) {
      margin-left: 20px;
    }
    &.articleShareStatic{
      padding-top: 0;
      padding-bottom: 20px;
      margin-left: 0;
      @media (min-width: 975px) {
        display: none;
      }
    }
    h4{
      margin: 0 0 10px;
      font-size: 8px;
      text-align: center;
      text-transform: uppercase;
      color: #767676;
    }
    a{
      display: block;
      .fa{
        width: 40px;
        height: 40px;
        display: block;
        border-radius: 50%;
        margin: 0 auto;
        margin-top: 4px;
        background-size: 26px auto;
        background-position: center;
        background-repeat: no-repeat;
        opacity: .5;
        &:hover{
          background-color: #fff;
          opacity: 1;
        }
      }
      .fa.fa-facebook{
        background-image: url(../assets/share-facebook.png);
      }
      .fa.fa-twitter{
        background-image: url(../assets/share-twitter.png);
      }
      .fa.fa-whatsapp{
        background-image: url(../assets/share-whatsapp.png);
      }
      .fa.fa-telegram{
        background-image: url(../assets/share-telegram.png);
      }
      .fa.fa-email{
        background-image: url(../assets/share-email.png);
      }
    }
    @media (max-width: 974px) {
      position: static;
      display: flex;
      left: 0;
      top: auto;
      transform: none;
      bottom: 70px;
      border-radius: 0;
      flex-wrap: wrap;
      padding: 20px 0 0;
      h4{
        width: 50px;
        padding-top: 6px;
        width: 100%;
        text-align: left;
        margin-bottom: 6px;
        font-size: 17px;
        text-transform: none;
      }
      .shareCnt{
        display: flex;
        margin-left: -5px;
        a{
          margin: 0;
          margin-right: 10px;
          padding: 0;
          .fa{
            margin: 0;
          }
        }
      }
    }
  }
</style>
<style scoped lang="scss">
  .contentLoading{
    padding-top: 60px;
  }
</style>
